import { ManagementTenant } from '@xeetr/types/models'

import ApiService from './common/API.service'


export class TenantService extends ApiService {
  getTenant = async (): Promise<ManagementTenant> => {
    const { data } = await this.get<ManagementTenant>(this.buildCommonUrl('tenant'))
    return data
  }
}
